
import { createTranslations } from '@/i18n/types';

export default createTranslations({
  en: {
    title: 'Welcome to SHOT',
    description: 'Choose how to sign in',
    openInTelegram: 'Or open in Telegram',
    loginError: 'Login failed. Please try again.',
    loginWithTelegram: 'Continue with Telegram',
    loginWithSteam: 'Continue with Steam',
    loggingIn: 'Signing you in…',
    userAgreement: 'User Agreement',
    privacyPolicy: 'Privacy Policy',
    companyInfo:
      'SHOT IN THE DARK GAME LTD\nCompany number 12412340\nRegistered office address\n60 Spennithorne Avenue, Leeds, West Yorkshire, England, LS16 6JA',
  },
  ru: {
    title: 'Добро пожаловать в SHOT',
    description: 'Выбери способ входа',
    openInTelegram: 'Или открой в Telegram',
    loginError: 'Ошибка входа. Попробуй ещё раз.',
    loginWithTelegram: 'Войти через Telegram',
    loginWithSteam: 'Войти через Steam',
    loggingIn: 'Выполняется вход…',
    userAgreement: 'Пользовательское соглашение',
    privacyPolicy: 'Политика конфиденциальности',
    companyInfo:
      'SHOT IN THE DARK GAME LTD\nCompany number 12412340\nRegistered office address\n60 Spennithorne Avenue, Leeds, West Yorkshire, England, LS16 6JA',
  },
  uz: {
    title: 'SHOTga xush kelibsiz',
    description: "Kirish usulini tanlang",
    openInTelegram: 'Yoki Telegramda oching',
    loginError: "Kirish xatosi. Iltimos, qayta urinib ko'ring.",
    loginWithTelegram: 'Telegram orqali kirish',
    loginWithSteam: 'Steam orqali kirish',
    loggingIn: 'Kirish amalga oshirilmoqda…',
    userAgreement: 'Foydalanuvchi shartnomasi',
    privacyPolicy: 'Maxfiylik siyosati',
    companyInfo:
      'SHOT IN THE DARK GAME LTD\nCompany number 12412340\nRegistered office address\n60 Spennithorne Avenue, Leeds, West Yorkshire, England, LS16 6JA',
  },
});
